import { SyntheticEvent, useCallback, useEffect, FC } from 'react';

import { useEditStore, useListStore } from 'page/CustomerPage/hooks';
import { Customer } from 'types/customer';
import { CustomerListView } from 'page/CustomerPage/components/CustomerListView';
import { validateSafetyUrl } from './utils';

export const CustomerList: FC = () => {
  const { loading, filteredCustomers, selectedCustomer, selectCustomer } =
    useListStore();
  const { openModal, fetchCustomer } = useEditStore();

  /**
   * 顧客一覧の行をクリックしたときの処理
   * @param customer 選択された顧客
   */
  const handleClickCustomer = (customer: Customer) => {
    selectCustomer(customer);
  };

  /**
   * 顧客環境URLへのリンクボタンをクリックした場合の処理
   */
  const handleClickCustomerPoseidonLinkButton = useCallback(
    (e: SyntheticEvent<HTMLButtonElement>, url: string) => {
      if (!validateSafetyUrl(url)) {
        // 安全なURLでなかった場合は押せない状態にした上で行をクリックした処理にしたい
        e.preventDefault();

        return;
      }

      // ボタンクリック時に行クリックの処理が行われないようにしたい
      e.stopPropagation();
    },
    [],
  );

  /**
   * 顧客が選択されたときの処理
   */
  useEffect(() => {
    if (!selectedCustomer) {
      return;
    }
    void fetchCustomer();
    openModal();
  }, [fetchCustomer, openModal, selectedCustomer]);

  return (
    <CustomerListView
      loading={loading}
      customers={filteredCustomers}
      validateSafetyPoseidonUrl={validateSafetyUrl}
      handleClickCustomer={handleClickCustomer}
      handleClickCustomerPoseidonLinkButton={
        handleClickCustomerPoseidonLinkButton
      }
    />
  );
};
